<template>
  <div class="story-content">
    <div v-for="(item, index) in contentArr" :key="index">
      <!-- 引言 -->
      <div
        v-if="item.type === 'foreword' && item.content !== ''"
        class="foreword-section"
      >
        <div style="font-size: 24px">“</div>
        {{ item.content }}
        <div class="border"></div>
      </div>

      <!-- 标题 -->
      <div v-else-if="item.type === 'title'" class="title-section han-cn-bold">
        {{ item.content }}
      </div>

      <!-- 文本 -->
      <div v-else-if="item.type === 'text'" class="text-section han-cn-bold">
        {{ item.content }}
      </div>

      <!-- 图片 -->
      <div v-else-if="item.type === 'image'" class="image-section">
        <div class="image-container">
          <img :src="item.content" class="story-image" />
          <div v-if="item.desc" class="image-desc">{{ item.desc }}</div>
        </div>
      </div>

      <!-- 文物 -->
      <div v-else-if="item.type === 'collection'" class="collection-section">
        <div class="top">
          <div class="artifact-image" :style="{ backgroundColor: `${item?.bgColor}` }">
            <img :src="item.coverUrl" class="story-image" />
          </div>
          <div class="pf-sc">
            <div class="title">{{ item.collectName }}</div>
            <div class="info">
              <span>朝代</span>
              <span>|</span>
              <span>{{ item.museumName }}</span>
            </div>
          </div>
        </div>
        <div v-if="item.desc" class="collect-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
 
export default {
  name: 'StoryContentRenderer',
  props: {
    contentArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },

};
</script>

<style lang="less" scoped>
.story-content {
  .content-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  // 引言样式
  .foreword-section {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: left;
    font-weight: 400;
    white-space: pre-wrap;
    color: rgba(0, 0, 0, 0.6);

    .border {
      margin-block: 32px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }
  }

  // 标题样式
  .title-section {
    font-size: 18px;
    line-height: 32px;
    text-align: left;
    white-space: pre-wrap;
    margin-top: 48px;
    margin-bottom: 16px;
    position: relative;
    text-indent: 8px;
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 3px;
      height: 18px;
      left: 0;
      top: 7px;
      border-radius: 6px;
      background-color: #977c58dd;
    }
  }

  // 文本样式
  .text-section {
    font-size: 16px;
    line-height: 32px;
    text-align: left;
    font-weight: 400;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: break-word;
    font-family: SourceHanSerifCN;
    margin-bottom: 20px;
  }

  // 图片样式
  .image-section {
    margin: 30px 0;
    text-align: center;

    .image-container {
      display: inline-block;
      max-width: 100%;

      .story-image {
        max-width: 100%;
        height: auto;
      }

      .image-desc {
        font-size: 14px;
        margin-top: 8px;
        line-height: 18px;
        text-align: center;
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  // 文物样式
  .collection-section {
    margin-block: 24px;
    .collect-desc {
      font-size: 14px;
      margin-top: 8px;
      margin-bottom: 48px;
      line-height: 18px;
      text-align: center;
      color: rgba(0, 0, 0, 0.5);
    }
    .top{
      width: 100%;
      height: fit-content;
      margin-top: 24px;
      margin-bottom: 15px;
      overflow: hidden;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 2px;
      border-radius: 8px;
    }
    .artifact-image {
      width: 334px;
      height: 206px;
      padding: 20px 0;
      img {
        margin: 0 auto;
        display: block;
        width: 297px;
        height: 166px;
      }
    }
    .pf-sc {
      height: fit-content;
      padding: 12px 16px;
      background: rgb(240, 243, 245);
      .title {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      .info {
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  // 未知类型样式
  .unknown-section {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 4px;
    padding: 10px;

    .unknown-content {
      color: #856404;
      font-size: 12px;
      margin: 0;
      font-family: monospace;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .story-content {
    padding: 15px;

    .collection-section .artifact-container {
      flex-direction: column;

      .artifact-image {
        align-self: center;
      }
    }
  }
}
</style>
